import { Injectable } from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import { tokenName } from '@angular/compiler';

@Injectable()
export class HttpInterceptorsService implements HttpInterceptor{

  constructor() { }


  public getToken(): string {
     return localStorage.loginToken;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        Authorization: `${localStorage.loginToken}`
      }
    });
    return next.handle(req);
  }
}
